export enum ReportDefinitionStatusEnum
{
    PendingScheduling = 1,
    InProgress,
    Sent,
    Paused,
    Cancelled
}

export enum ReportExecutionModeEnum
{
    Scheduled = 1,
    Now
}

export enum ReportFrequencyTypeEnum
{
    BetweenDates = 1,
    Monthly,
    Quarterly,
    Biannually,
    Annually
}

export enum ReportContentDeliveryTypeEnum
{
    Dynamic = 1,
    PDF
}

export enum KpiSectionEnum
{
    Claims = 1,
    ProfessionalSurveys,
    PatientSurveys,
    SocialNetworks,
    ImprovementPlans,
    Alerts
}

export enum MonthlyFrequencyEnum
{   
    January = 1,
    February,
    March,
    April,
    May,
    June,
    July,
    August,
    September,
    October,
    November,
    December
}

export enum QuarterlyFrequencyEnum
{   
    T1 = 1,
    T2,
    T3
}

export enum BiannuallyFrequencyEnum
{   
    S1 = 1,
    S2
}